import React from 'react';
import { Box, FormControlLabel, Checkbox, Typography } from '@mui/material';

interface CarveOutCheckboxesProps {
    applyMultiProcedureDisc: boolean;
    isCaseRate: boolean;
    onMultiProcChange: (checked: boolean) => void;
    onCaseRateChange: (checked: boolean) => void;
}

export const CarveOutCheckboxes: React.FC<CarveOutCheckboxesProps> = ({
    applyMultiProcedureDisc,
    isCaseRate,
    onMultiProcChange,
    onCaseRateChange
}) => {
    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={applyMultiProcedureDisc}
                            onChange={(e) => onMultiProcChange(e.target.checked)}
                        />
                    }
                    label="Apply Multi-Procedure Discount"
                />
                <Typography variant="caption" color="text.secondary" sx={{ ml: 4, mt: -0.5 }}>
                    When checked, this CarveOut will be subject to multi-procedure discount rules.
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={isCaseRate}
                            onChange={(e) => onCaseRateChange(e.target.checked)}
                        />
                    }
                    label="Case Rate"
                />
                <Typography variant="caption" color="text.secondary" sx={{ ml: 4, mt: -0.5 }}>
                    When checked, this rate applies to the entire case rather than per procedure.
                </Typography>
            </Box>
        </>
    );
};
